import { Grid } from "@mui/material";
import PageTitle from "components/UI/atoms/PageTitle";
import React from "react";
import { schema } from "./data";
import CreateFormSection from "components/UI/atoms/CreateFormSection";
import SchemaUIExtractor from "components/UI/organisms/SchemaUIExtractor";

const JobDetails = ({ t = (d) => d, data, errors, onChange }) => {
  return (
    <Grid container px={{ xs: 0, md: 4 }}>
      <PageTitle left>{t("Basic Information")}</PageTitle>
      <CreateFormSection classes="mt-2">
        <SchemaUIExtractor
          schema={schema}
          data={data}
          errors={errors}
          onChange={onChange}
        />
      </CreateFormSection>
    </Grid>
  );
};

export default JobDetails;
